import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { Dialog, DataGrid } from "../../../components";
import {
  GrupoServicoService,
  notification,
  ServicoService,
} from "../../../services";
import { responseErros } from "../../../utils";
import AddGrupoServico from "../add-grupo-servico/add-grupo-servico.view";
import { PermisoesHelper } from "../../../helpers";

const ListGrupoServico = () => {
  const grupoServicoService = new GrupoServicoService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-servicos-visualizar");
  const servicoService = new ServicoService();
  const [loading, setLoading] = useState(false);
  const [grupoServicoId, setGrupoServicoId] = useState(null);
  const [servicoList, setServicoList] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [gruposServico, setGruposServico] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 700,
      filtrar: true,
    },
  ];

  useEffect(() => {
    buscaGruposServico();
    buscarServico();
  }, []);

  const buscaGruposServico = async (query) => {
    const filter = {
      ...query,
    };
    setLoading(true);
    const result = await grupoServicoService.getAll(filter);
    if (!result.isAxiosError) {
      setRowCount(result.data.count);
      setGruposServico(result.data.rows);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarServico = async (filtro) => {
    const filtros = {
      ...filtro,
    };
    setLoading(true);
    const res = await servicoService.getAll(filtros);
    if (!res.isAxiosError) {
      setServicoList(res.data.rows);
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const handleOpenDialog = (id) => {
    setGrupoServicoId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setGrupoServicoId(null);
    setOpenDialog(false);
  };

  const handleDeleteGrupoServico = async (id) => {
    const servico = servicoList.some((item) => item.grupoServicoId === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir esse grupo de servico?`
    );
    if (retornoAlerta.isConfirmed) {
      if (servico) {
        notification.alertaGenericos(
          "Não se pode remover grupo inserido em outros cadastros"
        );
        return;
      }
      setLoading(true);
      const result = await grupoServicoService.deletar(id);
      if (!result.isAxiosError) {
        buscaGruposServico();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const sendServerDatagrid = (props) => {
    buscaGruposServico(props.filtros);
  };

  return (
    <ListLayout
      title="Grupos de Servico"
      loading={loading}
      onClickCadastrar={handleOpenDialog}
      permissaoButton={permissoesHelper.temPermisao("grupo-servicos-cadastrar")}
    >
      <DataGrid
        rows={gruposServico}
        columns={colunas}
        onClickEdit={handleOpenDialog}
        onClickDelete={handleDeleteGrupoServico}
        visualizarShow={permissoesHelper.temPermisao(
          "grupo-servicos-visualizar"
        )}
        editShow={permissoesHelper.temPermisao("grupo-servicos-editar")}
        deleteShow={permissoesHelper.temPermisao("grupo-servicos-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        rowCount={rowCount}
        hideFiltroAvancado
      />
      <Dialog
        disableEscapeKeyDown
        fullWidth
        maxWidth="md"
        open={openDialog}
        aria-labelledby="form-dialog-title"
      >
        <AddGrupoServico
          id={grupoServicoId}
          setCentrosCustos={setGruposServico}
          handleCloseDialog={handleCloseDialog}
          openDialog={openDialog}
          buscaGruposServico={buscaGruposServico}
        />
      </Dialog>
    </ListLayout>
  );
};

export default ListGrupoServico;
